import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=e795e29a&scoped=true"
import script from "./BackToTop.vue?vue&type=script&lang=js"
export * from "./BackToTop.vue?vue&type=script&lang=js"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=e795e29a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e795e29a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/dev-official-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e795e29a')) {
      api.createRecord('e795e29a', component.options)
    } else {
      api.reload('e795e29a', component.options)
    }
    module.hot.accept("./BackToTop.vue?vue&type=template&id=e795e29a&scoped=true", function () {
      api.rerender('e795e29a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BackToTop.vue"
export default component.exports